import * as SMH from '../../typings';
import getHttp from '../http';
import EventBus from '../event';
/**
 * 权限较弱的tokenManager 公共管理器
 */
export default class WeakAccessTokenManager<Token extends SMH.WeakToken> extends EventBus {
  /**
   * @description 超时宽容区间（单位：秒）
   * @memberof AccessTokenManager
   */
  readonly EXPIRE_OFFSET = 5 * 60;

  protected http: SMH.HTTP | null = null;

  protected storage: SMH.AccessTokenManagerStorage<Token>;

  protected httpParams: SMH.AccessTokenManagerHttpParams = {
    baseURL: '',
    userToken: '',
    organizationId: 0,
  };

  // token Map
  public tokenMap: Record<string, Token> = {};

  constructor(config: SMH.AccessTokenManagerConfig<Token>) {
    super();
    this.storage = config.storage;

    if (config.httpParams) {
      this.initHttpParams(config.httpParams);
      this.recoveryTokenMap();
    }
  }

  /**
   * @description 设定实例发送网络请求时所需的 organizationId 与 userToken
   * @param httpParams
   * @memberof AccessTokenManager
   */
  public initHttpParams(httpParams: SMH.AccessTokenManagerHttpParams) {
    const { baseURL, organizationId, userToken } = httpParams;
    organizationId && (this.httpParams.organizationId = organizationId);
    userToken && (this.httpParams.userToken = userToken);
    if (baseURL && (!this.httpParams.baseURL || this.httpParams.baseURL !== baseURL)) {
      this.httpParams.baseURL = baseURL;
    }

    this.http = getHttp({
      baseURL: this.httpParams.baseURL,
      ...(httpParams.envType && { envType: httpParams.envType }),
      eventBus: this,
    });
    if (this.httpParams.organizationId && this.httpParams.userToken) {
      this.fetch();
    }
  }

  /**
   * @description 拉取最新的文件操作登录态信息 (派生类中需要重载该函数)
   * @param
   * @memberof AccessTokenManager
   */
  public async fetch(params?: unknown, cycles?: number): Promise<any> {
    if (!this.http) {
      throw new Error('[SMH Warning] No http function.');
    }
  }

  protected async recoveryTokenMap() {
    const tokenMap = await this.storage.get();
    tokenMap && (this.tokenMap = tokenMap);
  }

  /**
   * @description 判断一个 tokenItem 是否有效
   * @param tokenItem
   * @returns
   */
  protected isAccessTokenValid = (tokenItem: Token | undefined): Boolean => {
    // 若 tokenItem 为空，则是无效的
    if (!tokenItem) {
      return false;
    }

    const { accessToken, expiresIn, updateTime } = tokenItem;
    if (!expiresIn || !updateTime || !accessToken) {
      return false;
    }

    const now = new Date().getTime() / 1000;
    const isExpired = Number(updateTime) + Number(expiresIn) - this.EXPIRE_OFFSET <= now;
    // 若 token 为空或过期，则是无效的
    if (!accessToken || isExpired) {
      return false;
    }
    return true;
  };

  clear(): void {
    this.tokenMap = {};
    this.storage.del();
  }
}
